module.exports = __webpack_public_path__ + "img/errorl.57aa460.svg";